import { createAsyncThunk } from '@reduxjs/toolkit';

import { APIUserGroupUserMembershipDelete, APIUserGroupUserMembershipGetList, APIUserGroupUserMembershipPost } from '../UserGroupUserMembership/UserGroupUserMembership.api';

export const fetchUserProfileUserGroups = createAsyncThunk(
    'userProfileUserGroups/fetchUserProfileUserGroups',
    async (item: { tenantId: string, userId: string }) =>
    {
        const { userId, tenantId } = item;
        const response = await APIUserGroupUserMembershipGetList({ userId, tenantId });
        return response.data.map(res => res.userGroup);
    }
);

export const postUserProfileUserGroup = createAsyncThunk(
    'userProfileUserGroups/postUserProfileUserGroup',
    async (item: { tenantId: string, userGroupId: string, userId: string }) =>
    {
        return APIUserGroupUserMembershipPost(item);
    }
);

export const deleteUserProfileUserGroup = createAsyncThunk(
    'userProfileUserGroups/deleteUserProfileUserGroup',
    async (item: { tenantId: string, userId: string, userGroupId: string }) =>
    {
        return APIUserGroupUserMembershipDelete(item);
    }
);
